import { apiSlice } from "./api/apiSlice";

export const unifiedTaskSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUnifiedTasksByLead: builder.query({
      query: ({ leadID }) => `/unified/tasks/unified-tasks/${leadID}`,
      providesTags: (res, err, arg) => [{ type: "Task", id: arg.leadID }]
    }),
  })
});

export const { useGetUnifiedTasksByLeadQuery } = unifiedTaskSlice;


